import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SecurityService } from '../../shared/security.service';
import { timer, of, from } from 'rxjs';
import { switchMap, retryWhen, map, filter, concatMap, mergeMap, catchError, flatMap } from 'rxjs/operators';
import { api, handleError, retryStrategy } from '../../shared/api-loaders';
import { Observable } from 'rxjs';
import { Parameter } from '../models/Parameter';

@Injectable()
export class ParametersService {

  constructor(private _http: HttpClient, private secSvc: SecurityService) { }


  stackParameters: any = null;

  async getStackParameter(key: string): Promise<any>{
    if (this.stackParameters == null) {

      let parameters = await timer(0).pipe(switchMap(
        x => {
          return this._http
            .get<Parameter[]>(api.getCurrentStackParameters())
        }), retryWhen(retryStrategy())).toPromise();

      this.stackParameters = {};
      for (let p of parameters) {
        this.stackParameters[p.key] = p.value;
      }
    }

    return new Promise(resolve=> resolve(this.stackParameters[ key ]));
  }


}
